<template>
  <div>
    <header id="header" class="clearfix">
      <nav
        id="nav"
        class="only_pc"
        v-if="
          getCurrentPath === '/' ||
          getCurrentPath === '/callenglish' ||
          getCurrentPath === '/edu-tech' ||
          getCurrentPath === '/imooc' ||
          getCurrentPath === '/aitutor' ||
          getCurrentPath === '/custom-cont'
        "
      >
        <ul>
          <li class="pointer" @click="newPage2('https://carrotglobal.com')">
            <a>기업교육:컨설팅</a>
          </li>
          <li
            v-if="getCurrentPath !== '/' || getCurrentPath !== '/callenglish'"
            @click.stop="moveRouter('/callenglish')"
            class="pointer"
          >
            <a>전화·화상 외국어</a>
          </li>
          <li
            @click.stop="moveRouter('/edu-tech')"
            class="pointer"
            :class="
              getCurrentPath === '/imooc' ||
              getCurrentPath === '/aitutor' ||
              getCurrentPath === '/custom-cont'
                ? 'on'
                : ''
            "
          >
            <a>온라인·AI과정</a>
          </li>
          <li
            class="pointer"
            @click="newPage2('https://carrotglobal.com/Introduce')"
          >
            <a>회사소개</a>
          </li>
          <li
            v-if="
              getCurrentPath !== '/edu-tech' &&
              getCurrentPath !== '/imooc' &&
              getCurrentPath !== '/aitutor' &&
              getCurrentPath !== '/custom-cont'
            "
            class="nav_tel"
          >
            <a id="nav_tel" href="tel:518-2603"
              >교육문의 <strong>{{ getTelNo }}</strong></a
            >
          </li>
        </ul>
      </nav>

      <ul
        class="sub_nav only_pc"
        v-if="
          getCurrentPath === '/edu-tech' ||
          getCurrentPath === '/imooc' ||
          getCurrentPath === '/aitutor' ||
          getCurrentPath === '/custom-cont'
        "
      >
        <li
          :class="getCurrentPath === '/imooc' ? 'on' : ''"
          @click.stop="moveRouter('/imooc')"
        >
          <a>i:MOOC 이러닝</a>
        </li>
        <li
          :class="getCurrentPath === '/aitutor' ? 'on' : ''"
          @click.stop="moveRouter('/aitutor')"
        >
          <a>AI튜터 영어회화</a>
        </li>
        <li
          :class="getCurrentPath === '/custom-cont' ? 'on' : ''"
          @click.stop="moveRouter('/custom-cont')"
        >
          <a>맞춤 컨텐츠 개발</a>
        </li>
      </ul>

      <span
        v-if="getCurrentPath !== '/global_edu/samsung'"
        class="menu"
        @click="isMenu = !isMenu"
      ></span>
      <!-- 메뉴 있던자리 -->
      <span
        class="nav_tel only_m"
        v-show="
          getCurrentPath === '/' ||
          getCurrentPath === '/callenglish' ||
          getCurrentPath === '/edu-tech'
        "
        ><a
          v-if="getCurrentPath === '/' || getCurrentPath === '/callenglish'"
          href="tel:518-2603"
          >교육문의 <strong>{{ getTelNo }}</strong></a
        ></span
      >

      <div v-if="isMenu" class="m_only_container">
        <div :class="isMenu ? 'm_nav on only_m' : 'm_nav only_m'">
          <span class="close" @click="isMenu = !isMenu">닫기</span>
          <ul
            v-if="
              getCurrentPath === '/' ||
              getCurrentPath === '/callenglish' ||
              getCurrentPath === '/edu-tech' ||
              getCurrentPath === '/imooc' ||
              getCurrentPath === '/aitutor' ||
              getCurrentPath === '/custom-cont'
            "
          >
            <li class="pointer" @click="newPage2('https://carrotglobal.com')">
              <a>기업교육:컨설팅</a>
            </li>
            <li
              v-if="getCurrentPath !== '/callenglish'"
              @click.stop="moveRouter('/callenglish')"
            >
              <a>전화·화상 외국어</a>
            </li>
            <li>
              <a @click.stop="moveRouter('/edu-tech')" href="#n"
                >온라인·AI과정</a
              >
              <ul
                class="sub_menu"
                v-if="
                  getCurrentPath === '/edu-tech' ||
                  getCurrentPath === '/imooc' ||
                  getCurrentPath === '/aitutor' ||
                  getCurrentPath === '/custom-cont'
                "
              >
                <li
                  :class="getCurrentPath === '/imooc' ? 'on' : ''"
                  @click.stop="moveRouter('/imooc')"
                >
                  <a>i:MOOC 이러닝</a>
                </li>
                <li
                  :class="getCurrentPath === '/aitutor' ? 'on' : ''"
                  @click.stop="moveRouter('/aitutor')"
                >
                  <a>AI튜터 영어회화</a>
                </li>
                <li
                  :class="getCurrentPath === '/custom-cont' ? 'on' : ''"
                  @click.stop="moveRouter('/custom-cont')"
                >
                  <a>맞춤 컨텐츠 개발</a>
                </li>
              </ul>
            </li>
            <li
              class="pointer"
              @click="newPage('https://carrotglobal.com/Introduce')"
            >
              <a>회사소개</a>
            </li>
          </ul>

          <ul v-if="getCurrentPath === '/re-location' || moveToMaster">
            <li><a @click="handleIsDispatch">파견 확정 및 교육</a></li>
            <li><a @click="handleIsDispatchBefore">파견 전</a></li>
            <li><a @click="handleIsDeparture">출국 및 초기정착</a></li>
            <li><a @click="handleIsDispatchIng">파견 중</a></li>
            <li><a @click="handleIsReturn">귀임</a></li>
          </ul>

          <ul v-if="getCurrentPath === '/global' || moveToMaster">
            <li><a @click="gotoPage('/global-sub1')">글로벌 역량</a></li>
            <li>
              <a @click="gotoPage('/global-sub2')">리더십 및 조직문화 강화</a>
            </li>
            <li><a @click="gotoPage('/global-sub3')">디지털 역량 강화</a></li>
            <li><a @click="gotoPage('/global-sub4')">평가 및 진단</a></li>
            <li><a @click="gotoPage('/global-sub5')">해외 연수</a></li>
            <li>
              <a @click="newPage2('https://carrotglobal.com/carrot/index.html')"
                >회사 소개</a
              >
            </li>
          </ul>
          <ul v-if="getCurrentPath === '/global-sub1' || moveToMaster">
            <li><a @click="gotoPage('/global-sub1')">글로벌 역량</a></li>
            <li>
              <a @click="gotoPage('/global-sub2')">리더십 및 조직문화 강화</a>
            </li>
            <li><a @click="gotoPage('/global-sub3')">디지털 역량 강화</a></li>
            <li><a @click="gotoPage('/global-sub4')">평가 및 진단</a></li>
            <li><a @click="gotoPage('/global-sub5')">해외 연수</a></li>
            <li>
              <a @click="newPage2('https://carrotglobal.com/carrot/index.html')"
                >회사 소개</a
              >
            </li>
          </ul>
          <ul v-if="getCurrentPath === '/global-sub2' || moveToMaster">
            <li><a @click="gotoPage('/global-sub1')">글로벌 역량</a></li>
            <li>
              <a @click="gotoPage('/global-sub2')">리더십 및 조직문화 강화</a>
            </li>
            <li><a @click="gotoPage('/global-sub3')">디지털 역량 강화</a></li>
            <li><a @click="gotoPage('/global-sub4')">평가 및 진단</a></li>
            <li><a @click="gotoPage('/global-sub5')">해외 연수</a></li>
            <li>
              <a @click="newPage2('https://carrotglobal.com/carrot/index.html')"
                >회사 소개</a
              >
            </li>
          </ul>
          <ul v-if="getCurrentPath === '/global-sub3' || moveToMaster">
            <li><a @click="gotoPage('/global-sub1')">글로벌 역량</a></li>
            <li>
              <a @click="gotoPage('/global-sub2')">리더십 및 조직문화 강화</a>
            </li>
            <li><a @click="gotoPage('/global-sub3')">디지털 역량 강화</a></li>
            <li><a @click="gotoPage('/global-sub4')">평가 및 진단</a></li>
            <li><a @click="gotoPage('/global-sub5')">해외 연수</a></li>
            <li>
              <a @click="newPage2('https://carrotglobal.com/carrot/index.html')"
                >회사 소개</a
              >
            </li>
          </ul>
          <ul v-if="getCurrentPath === '/global-sub4' || moveToMaster">
            <li><a @click="gotoPage('/global-sub1')">글로벌 역량</a></li>
            <li>
              <a @click="gotoPage('/global-sub2')">리더십 및 조직문화 강화</a>
            </li>
            <li><a @click="gotoPage('/global-sub3')">디지털 역량 강화</a></li>
            <li><a @click="gotoPage('/global-sub4')">평가 및 진단</a></li>
            <li><a @click="gotoPage('/global-sub5')">해외 연수</a></li>
            <li>
              <a @click="newPage2('https://carrotglobal.com/carrot/index.html')"
                >회사 소개</a
              >
            </li>
          </ul>
          <ul v-if="getCurrentPath === '/global-sub5' || moveToMaster">
            <li><a @click="gotoPage('/global-sub1')">글로벌 역량</a></li>
            <li>
              <a @click="gotoPage('/global-sub2')">리더십 및 조직문화 강화</a>
            </li>
            <li><a @click="gotoPage('/global-sub3')">디지털 역량 강화</a></li>
            <li><a @click="gotoPage('/global-sub4')">평가 및 진단</a></li>
            <li><a @click="gotoPage('/global-sub5')">해외 연수</a></li>
            <li>
              <a @click="newPage2('https://carrotglobal.com/carrot/index.html')"
                >회사 소개</a
              >
            </li>
          </ul>
          <ul v-if="getCurrentPath === '/global-sub6' || moveToMaster">
            <li><a @click="gotoPage('/global-sub1')">글로벌 역량</a></li>
            <li>
              <a @click="gotoPage('/global-sub2')">리더십 및 조직문화 강화</a>
            </li>
            <li><a @click="gotoPage('/global-sub3')">디지털 역량 강화</a></li>
            <li><a @click="gotoPage('/global-sub4')">평가 및 진단</a></li>
            <li><a @click="gotoPage('/global-sub5')">해외 연수</a></li>
            <li>
              <a @click="newPage2('https://carrotglobal.com/carrot/index.html')"
                >회사 소개</a
              >
            </li>
          </ul>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
export default {
  name: "Menu",
  data() {
    return {
      isMenu: false,
      sideBarcss: "sidebar off",
      moveToMaster: false,
      domain: "",
    };
  },
  mounted() {
    this.checkMoveToMaster();
    document.addEventListener("scroll", this.scrollEvents);
  },
  computed: {
    ...mapGetters(["getCurrentPath", "getTelNo", "getEmail"]),
  },
  watch: {
    /**
     * @description 라우터가 이동될때마다 감지
     */
    $route(to, from) {
      window.scrollTo(0, 0);
      this.setCurrentPath(to.path);
      this.checkMoveToMaster();
      const scroll = document.getElementsByClassName(
        `scroll-${from.path.replace("/", "")}`
      );
      if (scroll[0]) {
        scroll[0].classList.remove(`scroll-${from.path.replace("/", "")}`);
      }
      const tel_nav = document.getElementById("nav_tel");
      if (tel_nav && tel_nav[0]) {
        tel_nav.classList.remove(`scroll-${to.path.replace("/", "")}`);
      }
    },
  },
  created() {
    this.setCurrentPath(this.$router.currentRoute.path);
  },
  methods: {
    ...mapMutations({
      setCurrentPath: "setCurrentPath",
    }),
    checkMoveToMaster() {
      if (window.location.origin.includes("expatcare.co.kr")) {
        this.moveToMaster = true;
      }
    },
    sideBar() {
      const overlay = document.getElementById("overlay");
      if (this.sideBarcss === "sidebar off") {
        this.sideBarcss = "sidebar on";
      } else {
        this.sideBarcss = "sidebar off";
        overlay.style.display = "none";
      }
    },
    /**
     * @description : 페이지 이동
     */
    moveRouter(path) {
      this.$router.push(path).catch(() => {});
      this.setCurrentPath(path);
      this.isMenu = false;
    },
    newPage(path) {
      window.open(path, "_blank");
      this.sideBar();
    },
    newPage2(path) {
      window.open(path, "_blank");
      this.sideBar();
    },
    gotoPage(path) {
      window.open(path, "_self");
      this.sideBar;
    },
    scrollEvents() {
      const scrollY = window.scrollY;

      const nav = document.getElementById("nav");
      const tel_nav = document.getElementById("nav_tel");
      const header = document.getElementById("header");

      if (
        this.getCurrentPath === "/" ||
        this.getCurrentPath === "/callenglish" ||
        this.getCurrentPath === "/edu-tech" ||
        this.getCurrentPath === "/imooc" ||
        this.getCurrentPath === "/aitutor" ||
        this.getCurrentPath === "/custom-cont"
      ) {
        if (scrollY !== 0) {
          nav.classList.add(`scroll`);
          header.classList.add("scroll");
          tel_nav.classList.add(
            `scroll-${this.$router.currentRoute.path.replace("/", "")}`
          );
        } else {
          nav.classList.remove(`scroll`);
          header.classList.remove("scroll");
          tel_nav.classList.remove(
            `scroll-${this.$router.currentRoute.path.replace("/", "")}`
          );
        }
      }
    },
    handleIsDispatch() {
      document.getElementById("box_01").scrollIntoView({ behavior: "smooth" });
      this.isMenu = !this.isMenu;
    },
    handleIsDispatchBefore() {
      document.getElementById("box_02").scrollIntoView({ behavior: "smooth" });
      this.isMenu = !this.isMenu;
    },
    handleIsDeparture() {
      document.getElementById("box_03").scrollIntoView({ behavior: "smooth" });
      this.isMenu = !this.isMenu;
    },
    handleIsDispatchIng() {
      document.getElementById("box_04").scrollIntoView({ behavior: "smooth" });
      this.isMenu = !this.isMenu;
    },
    handleIsReturn() {
      document.getElementById("box_05").scrollIntoView({ behavior: "smooth" });
      this.isMenu = !this.isMenu;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/style/menu.scss";
</style>
